import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import React, {Component} from 'react';
import { Modal, Table } from 'react-bootstrap';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import swal from 'sweetalert';


var Config = require('../../../config');

class SearchImssShip extends Component{
    constructor(props){
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.search_idee = this.search_idee.bind(this);
        this.search_nss = this.search_nss.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onSelect = this.onSelect.bind(this);

        this.state = {
            show: false,
            search_type:"",
            nss:"",
            medical_attache:"",
            idee:"",
            list:[],
            search:""
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    handleShow(search = 'donor'){
        this.setState({show:true, search: search});
    }

    handleChange(e){
        

        if(e.target.name === 'search_type'){
            this.setState({
                nss:"",
                medical_attache:"",
                idee:""
            });
        }

        if(e.target.name === 'idee'){
            if(e.target.value.length < 51){
                this.setState({[e.target.name]: e.target.value});
            }
        }else{
            this.setState({[e.target.name]: e.target.value});
        }
    }

    handleClose(){
        this.setState({
            show:false,
            search_type:"",
            nss:"",
            medical_attache:"",
            idee:"",
            list:[]
        });
    }

    search_nss(e, complete){
		e.preventDefault();

		var valid = true;

		if(document.getElementById('search_type') !== null){
			if(this.state.search_type === ""){
				document.getElementById('search_type').classList.add('error');
			}else{
				document.getElementById('search_type').classList.remove('error');
			}
		}
	
		if(this.state.nss === ""){
			valid = false;
			if(document.getElementById('nss') !== null){
				document.getElementById('nss').classList.add('error');
			}
		}

		this.setState({list:[]})

		if(valid){
			this.props.waiting.handleShow('Buscando...');
            
			fetch(Config.default.apiGateway.URL+'hl7_imss/search_person?nss='+this.state.nss+'&agregado_medico='+this.state.medical_attache+
                '&hf_id='+sessionStorage.getItem('health_facilities_id')+'&complete='+complete, {
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined && response !== null){
					response.map((res)=>{
						res.check = false;
					});
					this.setState({list:response});

				}
			})
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}

	}

	search_idee(e){
		e.preventDefault();

		var valid = true;
		if(document.getElementById('search_type') !== null){
			if(this.state.search_type === ""){
				document.getElementById('search_type').classList.add('error');
			}else{
				document.getElementById('search_type').classList.remove('error');
			}
		}

		if(this.state.idee === ""){
			valid = false;
			if(document.getElementById('idee') !== null){
				document.getElementById('idee').classList.add('error');
			}
			
		}else{
			if(document.getElementById('idee') !== null){
				document.getElementById('idee').classList.remove('error');
			}
		}

		this.setState({list:[]})

		if(valid){
			this.props.waiting.handleShow('Buscando...');
            
			fetch(Config.default.apiGateway.URL+'hl7_imss/search_person?idee='+this.state.idee+'&hf_id='+
                sessionStorage.getItem('health_facilities_id')+'&complete=true', {
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
					this.props.waiting.handleClose();
				}
			}).then(response => {
				if(response !== undefined && response !== null){
					response.map((res)=>{
						res.check = false;
					});
					this.setState({list:response});
				}
			})
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

    onCheck(e, i){
        var list = this.state.list;

        list.forEach((item, j)=>{
            item.check = false;

            if(i === j){
                item.check = true;
            }
        });

        this.setState({list: list});
    }

    onSelect(){
        var list = this.state.list;
        var selected = [];

        list.forEach((item)=>{
            if(item.check){
                console.log("BUSQUEDA", item);
                if(this.state.search !== 'donor'){
                    item.id = item.patient_id;
                }
                

                selected = [item];
            }
        });

        if(this.state.search_type !== ""){
            if(selected.length > 0){
                this.props.updateState(selected);
                this.handleClose();
            }else{
                swal('Error', 'Debe seleccionar un nombre', 'error');
            }
        }else{
            swal('Error', 'Debe seleccionar un tipo de busqueda', 'error');
        }
        
    }

    render(){
        return (
            <Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Búsqueda</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group row'>
                        <div className='form-group col-xs-12'>
                            <div className="col-xs-12 col-sm-2">
                                <span className="span-min">Tipo</span>
                                <select name="search_type" id="search_type" value={this.state.search_type}
                                    onChange={this.handleChange} className="form-control">
                                    <option value="">Seleccione...</option>
                                    <option value="NSS">NSS</option>
                                    <option value="IDEE">IDEE</option>
                                </select>
                            </div>
                            {this.state.search_type === 'NSS' ?
                                <div>
                                    <div className="col-xs-12 col-sm-2">
                                        <span className="span-min" style={{marginRight:'5px'}}>NSS</span>
                                        <span>(*)</span>
                                        <MaskedFormControl type='text' name="nss" id="nss" 
                                        value={this.state.nss} onChange={this.handleChange} mask='1111111111' 
                                        className="form-control" placeholder=""/>
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <span className="span-min">Agregado Médico</span>
                                        <MaskedFormControl type='text' name="medical_attache" id="medical_attache" 
                                        value={this.state.medical_attache || ""} onChange={this.handleChange} mask='1A1111AA' 
                                        className="form-control" placeholder=""/>
                                    </div>
                                    <div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
                                        <button type="button" className="btn btn-info" style={{width:'100%'}}
                                            title="Buscar donador"
                                            onClick={(e)=>this.search_nss(e, true)}>
                                            BUSCAR
                                        </button>
                                    </div>
                                </div>
                            :this.state.search_type === 'IDEE' ?
                                <div>
                                    <div className="col-xs-12 col-sm-2">
                                        <span className="span-min" style={{marginRight:'5px'}}>IDEE</span>
                                        <span className="span-min">(*)</span>
                                        <input className="form-control" name="idee"
                                            id="idee" value={this.state.idee} onChange={this.handleChange} />
                                    </div>
                                    <div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
                                        <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar donador"
                                            onClick={this.search_idee}>
                                            BUSCAR
                                        </button>
                                    </div>
                                </div>
                            :null}
                        </div>
                        <div className='form-group col-xs-12'>
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nombre</th>
                                        <th>A. Paterno</th>
                                        <th>A. Materno</th>
                                        <th>Sexo</th>
                                        <th>IDEE</th>
                                        <th>NSS</th>
                                        <th>Agregado</th>
                                        <th>CURP</th>
                                        <th>Clave Procedencia</th>
                                        <th>Tipo Convenio</th>
                                        <th>Obervaciones</th>
                                        <th>Fecha Nacimiento</th>
                                        <th>Fecha Defunción</th>
                                        <th>Situación</th>
                                        <th>Derecho de incapacidad</th>
                                        <th>Calle</th>
                                        <th>Colonia</th>
                                        <th>Telefono</th>
                                        <th>Consultorio</th>
                                        <th>Turno</th>
                                        <th>Clave Unidad</th>
                                        <th>Clave Registro Patronal</th>
                                        <th>Clave Tipo Pension</th>
                                        <th>Fecha Limite Vigencia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.list.map((list, i)=>
                                        <tr key={i}>
                                            <td>
                                                <input type='checkbox' checked={list.check} value={list.check} onChange={(e)=>this.onCheck(e, i)} />
                                            </td>
                                            <td>{list.NOMBRE}</td>
                                            <td>{list.PRIMER_APELLIDO}</td>
                                            <td>{list.SEGUNDO_APELLIDO}</td>
                                            <td>{list.SEXO}</td>
                                            <td>{list.IDEE}</td>
                                            <td>{list.NSS}</td>
                                            <td>{list.AGREGADO_MEDICO}</td>
                                            <td> {list.CURP}</td>
                                            <td>{list.CVE_PROCEDENCIA  !== null ? list.CVE_PROCEDENCIA : ""  }</td>
                                            <td>{list.CVE_TIPO_CONVENIO  !== null ? list.CVE_TIPO_CONVENIO  : ""  }</td>
                                            <td>{list.OBSERVACIONES_CONVENIO  !== null ? list.OBSERVACIONES_CONVENIO   : ""  }</td>
                                            <td>
                                                {list.FECHA_NACIMIENTO  !== null ? 
                                                    moment(list.FECHA_NACIMIENTO.DateTime).format('DD/MM/YYYY')
                                                : ""}
                                            </td>
                                            <td>
                                                {list.FECHA_DEF  !== null ? 
                                                    moment(list.FECHA_DEF.DateTime).format('DD/MM/YYYY')
                                                : ""}
                                            </td>
                                            <td>{list.SITUACION !== null ? list.SITUACION: ""}</td>
                                            <td>{list.DERECHO_INCAPACIDAD !== null ? list.DERECHO_INCAPACIDAD: ""}</td>
                                            <td>{list.CALLE !== null ? list.CALLE : ""}</td>
                                            <td>{list.COLONIA !== null ? list.COLONIA : ""}</td>
                                            <td>{list.TELEFONO !== null ? list.TELEFONO : ""}</td>
                                            <td>{list.CONSULTORIO !== null ? list.CONSULTORIO : ""}</td>
                                            <td>{list.TURNO !== null ? list.TURNO : ""}</td>
                                            <td>{list.CLAVE_UNIDAD !== null ? list.CLAVE_UNIDAD : ""}</td>
                                            <td>{list.CLAVE_REGISTRO_PATRONAL !== null ? list.CLAVE_REGISTRO_PATRONAL : ""}</td>
                                            <td>{list.CLAVE_TIPO_PENSION !== null ? list.CLAVE_TIPO_PENSION : ""}</td>
                                           
                                            <td>
                                                {list.FECHA_LIMITE_VIGENCIA  !== null ? 
                                                    moment(list.FECHA_LIMITE_VIGENCIA.DateTime).format('DD/MM/YYYY')
                                                : ""}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <FlatButton primary={true} label="Cancelar"  onClick={this.handleClose}/>
                    <FlatButton primary={true} label="Aceptar"  onClick={this.onSelect}/>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default SearchImssShip;